import { NavItemsLoad, NavItemsLoadCompleted, NavItemsLoadFailed } from 'app/app-layout/state/actions/nav-items-load.action';
import { NavItemsReset } from 'app/app-layout/state/actions/nav-items-reset.action';

export { NavItemsLoad, NavItemsLoadCompleted, NavItemsLoadFailed } from 'app/app-layout/state/actions/nav-items-load.action';
export { NavItemsReset } from 'app/app-layout/state/actions/nav-items-reset.action';

export { NavItemsActionType } from './nav-items-action-type.enum';

export type NavItemsActions =

  NavItemsLoad |
  NavItemsLoadCompleted |
  NavItemsLoadFailed |

  NavItemsReset;
